import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SalesAppTourConfig: AgTechTourConfig = {
    id: 'sales-app-tour',
    name: 'Sellabull Tour',
    steps: [
        {
            targetId: 'sales-sidebar',
            title: 'Welcome to Sellabull',
            description: 'This sidebar is your main navigation hub. Use it to access contacts, reports, and settings for your sales.',
        },
        {
            targetId: 'sales-sale-selector',
            title: 'Sale Selector',
            description: 'Use this dropdown to switch between your sales. The selected sale drives all data shown in the workspace.',
        },
        {
            targetId: 'sales-contacts-button',
            title: 'Contacts',
            description: 'Manage your bidders and sellers here. Add new contacts, view their history, and track their activity across sales.',
        },
        {
            targetId: 'sales-reports-button',
            title: 'Reports',
            description: 'Generate and download reports for the current sale — including settlement sheets, lot summaries, and bidder activity.',
        },
        {
            targetId: 'sales-settings-button',
            title: 'Settings',
            description: 'Configure sale-level settings such as fees, terms, lot numbering, and other preferences for the current sale.',
        },
        {
            targetId: 'sale-header-create-button',
            title: 'Create Sale',
            description: 'Click the + button to create a new sale. This opens the sale creation form where you can configure the name, date, and other details.',
            position: 'bottom',
        },
        {
            targetId: 'sale-header-refresh-button',
            title: 'Refresh Sale',
            description: 'Reload the current sale to pull in the latest data. Useful after making changes or if another user has updated the sale.',
            position: 'bottom',
        },
        {
            targetId: 'sale-quick-actions-button',
            skipIfMissing: true,
            title: 'Quick Actions',
            description: 'Quick Actions gives you instant access to common tasks — creating and managing lots, registering bidders, and handling contacts — all from one menu.',
            onActivate: () => {
                const container = document.getElementById('sale-quick-actions-button');
                container?.querySelector('button')?.click();
            },
        },
        {
            targetId: 'sale-quick-actions-lots',
            skipIfMissing: true,
            title: 'Lot Actions',
            description: 'Manage everything lot-related from here — create new lots, import in bulk, adjust sale order, and open the selling or update views.',
        },
        {
            targetId: 'sale-quick-actions-bidders',
            skipIfMissing: true,
            title: 'Bidder Actions',
            description: 'Quickly view all registered bidders or register a new bidder for the current sale.',
        },
        {
            targetId: 'sale-quick-actions-contacts',
            skipIfMissing: true,
            title: 'Contact Actions',
            description: 'View, create, or import contacts associated with this sale without navigating away from the workspace.',
        },
        {
            targetId: 'sale-workspace-tab-overview',
            skipIfMissing: true,
            title: 'Overview',
            description: 'The Overview tab gives you a snapshot of your current sale — key metrics, recent activity, and quick access to common actions.',
            closePopupsOnActivate: true,
            onActivate: () => document.getElementById('sale-workspace-tab-overview')?.click(),
        },
        {
            targetId: 'sale-workspace-tab-planning-tasks',
            skipIfMissing: true,
            title: 'Planning Tasks',
            description: 'Keep your sale prep on track. Add tasks or apply a template, set priorities and due dates, and assign work to your team.',
            onActivate: () => document.getElementById('sale-workspace-tab-planning-tasks')?.click(),
        },
        {
            targetId: 'sale-workspace-tab-manage-bidders',
            skipIfMissing: true,
            title: 'Manage Bidders',
            description: 'Add, edit, and organize the bidders registered for this sale. You can assign bidder numbers and view bidder history here.',
            onActivate: () => document.getElementById('sale-workspace-tab-manage-bidders')?.click(),
        },
        {
            targetId: 'sale-workspace-tab-sell-lots',
            skipIfMissing: true,
            title: 'Sell Lots',
            description: 'Record lot sales as the auction runs. Select a lot, enter the winning bidder and price, then confirm the sale.',
            onActivate: () => document.getElementById('sale-workspace-tab-sell-lots')?.click(),
        },
        {
            targetId: 'sale-workspace-tab-perform-invoicing',
            skipIfMissing: true,
            title: 'Perform Invoicing',
            description: 'Generate invoices for sold lots. Review charges, apply credits, and finalize invoices to send to buyers.',
            onActivate: () => document.getElementById('sale-workspace-tab-perform-invoicing')?.click(),
        },
        {
            targetId: 'sale-workspace-tab-reports',
            skipIfMissing: true,
            title: 'Reports',
            description: 'View and export sale reports — settlement sheets, lot summaries, bidder activity, and more.',
            onActivate: () => document.getElementById('sale-workspace-tab-reports')?.click(),
        },
    ]
}
